import React, { useCallback } from 'react';
import PaymentCard from './PaymentCard';
import { Wallet } from '../../../../../../providers/DonorProvider/interfaces';
import { Text } from '../../../common/Text/Text';
import { Secure } from '../../../../../secure';
import { Button, Modal } from '../../../../../ui';

type ChangePaymentModalProps = {
    id?: string;
    open: boolean;
    selectedCard: Wallet;
    wallet: Wallet[];
    setCard: (wallet: Wallet) => unknown;
    handleModalClose: () => unknown;
    handleAddPaymentOpen: () => unknown;
};

const ChangePaymentModal: React.FC<ChangePaymentModalProps> = ({
    id = 'change-payment-modal',
    open,
    selectedCard,
    wallet,
    setCard,
    handleModalClose,
    handleAddPaymentOpen,
}) => {
    const onAddPaymentMethod = useCallback(() => {
        handleAddPaymentOpen();
        handleModalClose();
    }, [handleAddPaymentOpen, handleModalClose]);

    const handleCardClick = useCallback(
        (card: Wallet) => {
            setCard(card);
            handleModalClose();
        },
        [setCard, handleModalClose],
    );

    if (!open) {
        return null;
    }
    return (
        <Modal
            id={id}
            open={true}
            onClose={handleModalClose}
        >
            <div className="flex flex-col gap-4 align-middle justify-center w-[412px] mobile:w-full">
                <Text
                    id={`${id}-title`}
                    variant={'large'}
                    className={'heading'}
                >
                    Change Payment
                </Text>
                <Secure
                    id={`${id}-security-info`}
                    className={'info'}
                >
                    Your information is secure
                </Secure>
                <div
                    id={`${id}-wallet-list`}
                    className={'wallet'}
                >
                    {wallet.map((card) => (
                        <PaymentCard
                            id={`${id}-wallet-${card.id}`}
                            card={card}
                            key={card.id}
                            isSelected={selectedCard.id === card.id}
                            onClick={handleCardClick}
                        />
                    ))}
                </div>
                <Button
                    id={`${id}-add-payment-button`}
                    className="w-full"
                    onClick={onAddPaymentMethod}
                    variant="plain-secondary"
                >
                    <svg
                        id={`${id}-add-payment-icon`}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill={'none'}
                        xmlns={'http://www.w3.org/2000/svg'}
                    >
                        <path
                            id={id ? `${id}-vertical-line` : undefined}
                            d={'M12 5V19'}
                            stroke="currentColor"
                            strokeWidth={'2'}
                            strokeLinecap={'round'}
                            strokeLinejoin={'round'}
                        />
                        <path
                            id={id ? `${id}-horizontal-line` : undefined}
                            d={'M5 12H19'}
                            stroke="currentColor"
                            strokeWidth={'2'}
                            strokeLinecap={'round'}
                            strokeLinejoin={'round'}
                        />
                    </svg>
                    Add Payment Method
                </Button>
            </div>
        </Modal>
    );
};

export default ChangePaymentModal;
